import logo from '../images/distinguishedlogo.svg'
import insta from '../images/instagram-brands.svg'
import phone from '../images/phone-solid.svg'
import email from '../images/envelope-regular.svg'

import './Footer.css'
export default function Footer(){
    return (
        <section id="contacts">
            <div id="contacts-container">
                <div id="footer-wrapper">
                    <a href="#home">
                        <img src={logo} alt="company logo"/>
                    </a>
                    <div id='footer-content'>
                        <div id='company-links'>
                            <h3>COMPANY</h3>
                            <a href='#about'>About us</a>
                            <a href='#services'>Services</a>
                            <a href='mailto:Distinguishedhhc@yahoo.com?subject=I%27m%20interested%20in%20working%20as%20a...'>Careers</a>
                        </div>
                        <div id='company-contacts'>
                            <div>
                                <a href='https://www.instagram.com/distinguishedhhc'><img src={insta} alt='instagram' />@Distinguishedhhc</a>
                                <a href='tel:+1954-987-2445'><img src={phone} alt='instagram' /> (954) 987-2445</a>
                                <a href='mailto:Distinguishedhhc@yahoo.com'><img src={email} alt='instagram' />Distinguishedhhc@yahoo.com</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-divider"></div>
            <div id="footer-copyright">
                Copyright © 2025 Distinguished Home Health Care Services
            </div>
        </section>
    )
}